import { useTranslation } from "lib/i18n/translation"
import HtmlParser from "react-html-parser"

export const BlockSpecialRate = () => {
	const { c } = useTranslation()

	return (
		<div className="item">
			<div className="item-content">
				<h3 className="title">{HtmlParser(c("svod-special-rates"))}</h3>
				<div className="description">
					<p>{c("svod-many-people")}</p>
				</div>
				<p>{c("svod-contact")} :<br />
					<a
						href="mailto:partenariats@lacinetek.com"
						rel="nofollow noopener"
						title={c("svod-contact")}
					>
						partenariats@lacinetek.com
					</a>
				</p>
			</div>
		</div>
	)
}
